import { forwardRef } from 'react';
import { cn } from '../../utils/cn';

const Input = forwardRef(function Input({ label, error, icon, className, ...props }, ref) {
  return (
    <div className="space-y-1.5">
      {label && <label className="block text-xs font-semibold text-navy-500 uppercase tracking-wider">{label}</label>}
      <div className="relative">
        {icon && <span className="absolute left-3 top-1/2 -translate-y-1/2 text-navy-400">{icon}</span>}
        <input
          ref={ref}
          className={cn(
            'w-full rounded-xl border bg-white px-4 py-2.5 text-sm text-navy-800 placeholder-navy-300',
            'transition-all duration-200 focus-ring',
            icon && 'pl-10',
            error ? 'border-red-400 focus:ring-red-400/40' : 'border-surface-300 hover:border-surface-400',
            className,
          )}
          {...props}
        />
      </div>
      {error && <p className="text-xs text-red-500 font-medium">{error}</p>}
    </div>
  );
});

export default Input;
